// libs
import { useMedia } from "react-use";
import { useTheme } from "styled-components";
// components
import ButtonText from "./buttons/ButtonText";
import { FlexContainer, FlexItem } from "./Flex";
import IconButton from "./IconButton";
import SearchField from "./SearchField";

interface SearchHeaderProps {
  searchInputValue: string;
  onSearchInputChange: React.ChangeEventHandler<HTMLInputElement>;
  onSubmitSearch?: () => void;
  onToggleFilterClick: React.MouseEventHandler<HTMLButtonElement>;
}

function SearchHeader({
  searchInputValue,
  onSearchInputChange,
  onSubmitSearch,
  onToggleFilterClick,
}: SearchHeaderProps) {
  const theme = useTheme();

  const isWide = useMedia(`(min-width: ${theme.breakpoints[1]})`);

  return (
    <FlexContainer
      m={[-2, -3]}
      alignItems="center"
      justifyContent={["space-between", null, null, "flex-start"]}
    >
      <FlexItem p={[2, 3]} flex={["1", "0 0 340px"]}>
        <SearchField
          label="Search a collection"
          iconColor="blueDark"
          value={searchInputValue}
          onSubmit={onSubmitSearch}
          onChange={onSearchInputChange}
        />
      </FlexItem>
      {/* <FlexItem p={[2, 3]}>
        {isWide ? (
          <ButtonText
            icon="navigateNext"
            iconColor="blueDark"
            onClick={onToggleFilterClick}
          >
            Advanced search options
          </ButtonText>
        ) : (
          <IconButton
            size="md"
            color="blueDark"
            onClick={onToggleFilterClick}
            icon="apps"
          />
        )}
      </FlexItem> */}
    </FlexContainer>
  );
}

export default SearchHeader;
